import 'core-js/stable';
import 'regenerator-runtime/runtime';
import {
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query';
import {createRoot} from 'react-dom/client';
import {IntlProvider} from 'react-intl';
import Modal from 'react-modal';
import {BrowserRouter} from 'react-router-dom';
import {
    App,
    Auth0ProviderWithRedirectProcessor,
    ConfigProvider,
    ErrorBoundary,
    HubSpotLoader,
} from './health-insights';
import messages from './i18n/messages.json';

import '../css/genomics-health-insights.pcss';

// Get the element where we will render the application into…
const container = document.getElementById('root');

// Tell the modal where the application is rendered into, so that it can apply aria-hidden when a modal is open…
Modal.setAppElement(container);

// Create the React Query client, plus add the variable to enable the TanStack Query DevTools to connect…
const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Disable retries, become problematic when user hasn't consented, etc
            retry: false,

            // 2 minutes in milliseconds
            staleTime: 120000,
        },
    },
});
window.__TANSTACK_QUERY_CLIENT__ = queryClient;

const root = createRoot(container);
root.render(
    <IntlProvider
        defaultLocale={'en'}
        locale={'en'}
        messages={messages}
    >
        <ConfigProvider>
            <BrowserRouter>
                <QueryClientProvider client={queryClient}>
                    <Auth0ProviderWithRedirectProcessor>
                        <HubSpotLoader>
                            <ErrorBoundary>
                                <App />
                            </ErrorBoundary>
                        </HubSpotLoader>
                    </Auth0ProviderWithRedirectProcessor>
                </QueryClientProvider>
            </BrowserRouter>
        </ConfigProvider>
    </IntlProvider>,
);
